/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.component[_ngcontent-%COMP%]{width:48px;height:48px;font-size:25px;cursor:pointer;cursor:hand}.user[_ngcontent-%COMP%]{border-radius:100%;border:3px solid;padding:11px;height:48px}.plus[_ngcontent-%COMP%]{position:absolute;display:-webkit-box;display:flex;margin-top:6px;margin-left:28px;font-size:13px}"];
export { styles as styles };
